import { render, staticRenderFns } from "./CommWithdraw.vue?vue&type=template&id=a2dbfbae&scoped=true&"
import script from "./CommWithdraw.vue?vue&type=script&lang=js&"
export * from "./CommWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./CommWithdraw.vue?vue&type=style&index=0&id=a2dbfbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dbfbae",
  null
  
)

export default component.exports